import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  Icon,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Textarea from "@mui/joy/Textarea";

dayjs.extend(utc);
dayjs.extend(timezone);

const CustomInput = (props) => {
  const [focused, setFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleFocused = (event) => {
    //props.setFocused(event.target.id);
  };

  const handleChange = (event) => {
    if(props.setValue != undefined){
      props.setValue(event.target.value);
    }
  };

  const handleClose = () => {
    props.setClose(false);
  };

  const handleOpen = () => {
    if(props.setOpen != undefined){
     props.setOpen(true);
    }
  };

  const handleChangeSwitch = (event) => {
    props.setValue(event.target.checked);
  };

  const handleChangeMultiSelect = (event, values) => {
    if (values != null && values.length > 0) {
      let selectedValues = [];
      values.map((x) => selectedValues.push(x.value));
      props.setValue(selectedValues);
    } else {
      props.setValue([]);
    }
  };

  const handleChangeAutocomplete = (event, selectedItem) => {
    if (selectedItem != null && selectedItem != undefined) {
      props.setValue(selectedItem);
    } else {
      props.setValue(null);
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChangeNumber = (event) => {
    event.preventDefault();
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    if (props.setValue !== undefined && props.setValue !== null) {
      props.setValue(event.target.value);
    }
  };

  // Responsive layout: stack label/input vertically on mobile (xs),
  // respect the caller-provided textCol/inputCol ratio from sm upward.
  const textColResponsive = { xs: 12, sm: props.textCol };
  const inputColResponsive = { xs: 12, sm: props.inputCol };

  return (
    <Box>
      <Grid container>
        {props.labelText !== undefined ? (
          <Grid
            item
            xs={textColResponsive.xs}
            sm={textColResponsive.sm}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "flex-start", sm: "left" },
            }}
          >
            <FormLabel className={props.classLabel} htmlFor={props.id}>
              {props.labelText}
            </FormLabel>
          </Grid>
        ) : null}
        <Grid
          item
          xs={inputColResponsive.xs}
          sm={inputColResponsive.sm}
          display="flex"
          sx={{ p: 0.5 }}
        >
          {props.type !== undefined && props.type == "text" ? (
            <Input
              id={props.id}
              type="text"
              sx={{ width: "100%"}}
              name={props.name}
              itemID={props.name}
              className={props.classInput}
              inputRef={props.valueRef}
              value={props.value}
              onChange={handleChange}
              onFocus={handleFocused}
              disabled={props.disabled}
              defaultValue={props.defaultValue}
            ></Input>
          ) : null}
          {props.type !== undefined && props.type == "password" ? (
            <Input
              id={props.id}
              type={showPassword ? "text" : "password"}
              sx={{ width: "100%" }}
              className={props.classInput}
              inputRef={props.valueRef}
              onFocus={handleFocused}
              rows={props.rows}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            ></Input>
          ) : null}
          {props.type !== undefined && props.type == "date" ? (
            <DatePicker
              id={props.id}
              sx={{ width: "100%" }}
              className={props.classInput}
              value={props.valueRef}
              onChange={(newValue) => props.setValue(newValue)}
              format="YYYY-MM-DD"
              slotProps={{
                textField: { variant: "standard" },
                field: { clearable: true },
              }}
              timezone="UTC"
            />
          ) : null}
          {props.type !== undefined && props.type == "datetime" ? (
            <DateTimePicker
              id={props.id}
              sx={{ width: "100%" }}
              className={props.classInput}
              value={props.valueRef}
              onChange={(newValue) => props.setValue(newValue)}
              format="YYYY-MM-DD HH:mm"
              ampm={false}
              slotProps={{
                textField: { variant: "standard" },
                field: { clearable: true },
                ...(props.wideTimeColumns && {
                  desktopPaper: {
                    sx: {
                      "& .MuiMultiSectionDigitalClockSection-root": {
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        "&::-webkit-scrollbar": { display: "none" },
                      },
                    },
                  },
                }),
              }}
              timezone={props.localTimezone ? "default" : "UTC"}
            />
          ) : null}
          {props.type !== undefined && props.type == "file" ? (
            <Input
              id={props.id}
              type="file"
              sx={{ width: "100%" }}
              className={props.classInput}
              inputRef={props.valueRef}
              onFocus={handleFocused}
              inputProps={{ accept: props.acceptedContentTypes }}
              disabled={props.disabled}
              onInput={props.onInput}
              hidden={props.hidden}
            ></Input>
          ) : null}
          {props.type !== undefined && props.type == "number" ? (
            <FormControl sx={{ width: "100%" }} error={props.error}>
              <Input
                id={props.id}
                type="number"
                sx={{ width: "100%" }}
                className={props.classInput}
                inputRef={props.valueRef}
                onFocus={handleFocused}
                disabled={props.disabled}
                onChange={handleChangeNumber}
                value={props.value}
                inputProps={{ max: props.max, min: 0, step: props.step || 1 }}
              />
              {props.helperText && (
                <FormHelperText sx={{ fontSize: "0.75rem", lineHeight: 1, mt: 0.25 }}>
                  {props.helperText}
                </FormHelperText>
              )}
            </FormControl>
          ) : null}
          {props.type !== undefined && props.type == "select" ? (
            <Select
              variant="standard"
              id={props.id}
              value={props.valueRef}
              className={props.classInput}
              sx={{ width: "100%" }}
              onChange={handleChange}
              //onClose={handleClose}
              onOpen={handleOpen}
              MenuProps={MenuProps}
              disabled={props.disabled}
            >
              <MenuItem key={0} value={""}>
                -
              </MenuItem>
              {props.selectItems == undefined && props.selectItems == 0 ? (
                <div>Loading...</div>
              ) : (
                props.selectItems.map((x) => (
                  <MenuItem key={x.value} value={x.value}>
                    {x.text}
                  </MenuItem>
                ))
              )}
            </Select>
          ) : null}
          {props.type !== undefined && props.type == "multiselect" ? (
            <Autocomplete
              multiple
              id="tags-standard"
              options={props.selectItems}
              getOptionLabel={(option) => option.text}
              sx={{ width: "100%" }}
              onChange={handleChangeMultiSelect}
              renderInput={(params) => (
                <TextField {...params} variant="standard" />
              )}
              disabled={props.disabled}
            />
          ) : null}
          {props.type !== undefined && props.type == "autocomplete" ? (
            <Autocomplete
              disablePortal
              value={props.value}
              getOptionLabel={(option) => option.text}
              options={props.selectItems}
              onChange={handleChangeAutocomplete}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} variant="standard" />
              )}
            />
          ) : null}
          {props.type !== undefined && props.type == "switch" ? (
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={props.valueRef}
                    onChange={handleChangeSwitch}
                    size="large"
                  />
                }
              />
            </FormGroup>
          ) : null}
          {
            props.type !== undefined && props.type==='textMultiline' ? 
            (
                <Textarea
                    name="Solid"
                    minRows={3}
                    value={props.value}
                    onChange={handleChange}
                    sx={{width: '100%'}}
                />
            )
            : null
          }
          {props.type !== undefined && props.type == "multiline" ? (
            <TextField
              id={props.id}
              sx={{ width: "100%" }}
              name={props.name}
              itemID={props.name}
              className={props.classInput}
              inputRef={props.valueRef}
              value={props.value}
              onChange={handleChange}
              onFocus={handleFocused}
              disabled={props.disabled}
              defaultValue={props.defaultValue}
              label=""
              multiline
              fullWidth
              rows={props.rows}
              variant="standard"
              inputProps={{ maxLength: props.maxLength }}
              helperText={
                props.maxLength !== undefined
                  ? `${(props.value || "").length}/${props.maxLength}`
                  : undefined
              }
            />
          ) : null}
          {props.iconComponent !== undefined ? (
            <Icon component={props.iconComponent}/>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomInput;
